import styled from "styled-components";


export const NoDataFoundWrapper = styled.div`
.noDataFoundGif{
    max-width:300px;
}
`;
